import { PermissionResource } from '@entities/tenant/permission';

import { requirePermission } from '../../../require-permission';

export const discountsLoader = requirePermission(PermissionResource.TenantDiscounts);
